import graphQLAdapter from "@/adapters/graphQL.adapter.js";
import Product from "@/entities/product.entity.js";

/**
 * Order Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.getProducts = getProducts.bind(this);
    this.getProductDisplaySetting = getProductDisplaySetting.bind(this);
    this.updateProductDisplaySetting = updateProductDisplaySetting.bind(this);
    this.productDisplaySettingSource = productDisplaySettingSource.bind(this);
    this.productDisplaySettingSourceUpdate = productDisplaySettingSourceUpdate.bind(this);
  }
  /**
   * Get the list of orders
   *
   * @static
   * @returns {Promise<Object|null>} Promise object represents the list of orders
   */
  async list (param) {
    const res = await this.getProducts(param);
    return res.data.products.map(el => Product.fromJson(el));
  }

  /**
   * Get the productDisplaySetting
   *
   * @static
   * @returns {Promise<Object|null>} Promise object represents the list of orders
   */
  async productDisplaySetting (param) {
    const res = await this.getProductDisplaySetting(param);
    return res.data.productDisplaySetting;
  }

  /**
   * Get the productDisplaySetting
   *
   * @static
   * @returns {Promise<Object|null>} Promise object represents the list of orders
   */
  async updateProductDisplaySetting (param) {
    const res = await this.updateProductDisplaySetting(param);
    return res.data.productDisplaySettingUpdate.map(el => Product.fromJson(el));
  }
}

function getProducts (
  // 2023/9/4 得意先ユーザーの実行には得意先IDが必要になった。
  // https://github.com/TheDesignium/nanokos/pull/143
  param = {
    clientGroupId: "",
    q: {
      categoryId: "",
    },
  }
) {
  const query = `
  query products(
    $q: ProductFilterConditions,
    $clientGroupId: ID
  ) {
    products(
      q: $q,
      clientGroupId: $clientGroupId
    ){
      id
      display
      number
      name
      imageUrl
      category {
        id
        display
        name
      }
      variations {
        id
        size
        height
        width
        depth
        stock
        stockExpression
      }
      description
    }
  }
`;
  return this.adapter.query(query, param);
}

function getProductDisplaySetting (
  param = {
    clientGroupId: "",
  }
) {
  const query = `
  query productDisplaySetting($clientGroupId: ID!) {
    productDisplaySetting(clientGroupId: $clientGroupId){
      showCategories
      hideCategories
      showProducts
      hideProducts
    }
  }
`;
  return this.adapter.query(query, param);
}

function updateProductDisplaySetting (
  param = {
    clientGroupId: "",
    input: {
      hideCategories: [],
      hideProducts: [],
      showCategories: [],
      showProducts: [],
    },
  }
) {
  const query = `
  mutation (
    $clientGroupId: ID!,
    $input: ProductDisplaySettingInput!
  ) {
    productDisplaySettingUpdate(
      clientGroupId: $clientGroupId,
      input: $input
    ) {
      showCategories
      hideCategories
      showProducts
      hideProducts
    }
  }
`;
  return this.adapter.query(query, param);
}

function productDisplaySettingSource (
  param = {
    clientGroupId: "",
  }
) {
  const query = `
  query productDisplaySettingSource($clientGroupId: ID!) {
    productDisplaySettingSource(clientGroupId: $clientGroupId)
  }
`;
  return this.adapter.query(query, param);
}

function productDisplaySettingSourceUpdate (
  param = {
    clientGroupId: "",
    sourceClientGroupId: "",
  }
) {
  const query = `
  mutation (
    $clientGroupId: ID!,
    $sourceClientGroupId: ID!
  ) {
    productDisplaySettingSourceUpdate(
      clientGroupId: $clientGroupId,
      sourceClientGroupId: $sourceClientGroupId
    )
  }
`;
  return this.adapter.query(query, param);
}
